import { useReactiveVar } from '@apollo/client'
import { Typography } from '@material-ui/core'
import {
    bpRemoveConfirmation,
    closeBPRemoveConfirmation,
} from 'api/graphQL/reactiveVars/workspaceToggles'
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import React, { useEffect } from 'react'
import { BP_PANEL_TEXT } from '../constants'

export const BPRemoveConfirmationDialog = () => {
    const state = useReactiveVar(bpRemoveConfirmation)

    // Settle any pending awaiter as `false` if the dialog is unmounted while
    // a confirmation is in flight (e.g. workspace navigation), so the apply
    // hook's `await` doesn't hang and leak its closure.
    useEffect(() => {
        return () => {
            const current = bpRemoveConfirmation()
            if (current.open) closeBPRemoveConfirmation(false)
        }
    }, [])

    return (
        <ConfirmationDialog
            openDialog={state.open}
            dialogHeading={BP_PANEL_TEXT.REMOVE_DIALOG_HEADING}
            confirmMessage=""
            contentNode={
                <Typography>{BP_PANEL_TEXT.REMOVE_DIALOG_BODY}</Typography>
            }
            cancelText={BP_PANEL_TEXT.REMOVE_DIALOG_CANCEL}
            confirmText={BP_PANEL_TEXT.REMOVE_DIALOG_CONFIRM}
            size="small"
            handleDialogClose={() => closeBPRemoveConfirmation(false)}
            dialogActionCallback={() => closeBPRemoveConfirmation(true)}
        />
    )
}
